// Guided tours point at the photo gallery's "Watermark settings" button
// through this `data-tour` anchor (see
// `src/modules/product-updates/tours/tourTypes.ts`). Kept out of
// `NewImageGallery.tsx` so tour definitions import no UI code.
export const WATERMARK_SETTINGS_ANCHOR = 'watermark-settings';
